import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  fetchDashboardFailed,
  fetchDashboardRequested,
  fetchDashboardSucceeded,
  createComponentFailed,
  createComponentRequested,
  createComponentSuccessed,
  updateComponentFailed,
  updateComponentRequested,
  updateComponentSuccessed,
  deleteComponentFailed,
  deleteComponentRequested,
  deleteComponentSuccessed,
} from '../../../actions';
import api from '../../../api';

export function* fetchDashboardRequest() {
  yield put(fetchDashboardRequested());

  try {
    const { items } = yield call(request, api.getDashboard);

    const action = fetchDashboardSucceeded(items);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchDashboardFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* fetchDashboardIntervalRequest() {
  yield put(fetchDashboardRequested());

  try {
    const { items } = yield call(request, api.getDashboard);

    const action = fetchDashboardSucceeded(items);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchDashboardFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* createComponentRequest(type, data) {
  yield put(createComponentRequested(type, data));

  try {
    const { item } = yield call(request, api.createComponent, type, data);

    const action = createComponentSuccessed(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createComponentFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateComponentRequest(type, id, data) {
  yield put(updateComponentRequested(type, id, data));

  try {
    const { item } = yield call(request, api.updateComponent, type, id, data);

    const action = updateComponentSuccessed(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateComponentFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteComponentRequest(id) {
  yield put(deleteComponentRequested(id));

  try {
    const { item } = yield call(request, api.deleteComponent, id);

    const action = deleteComponentSuccessed(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteComponentFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
